import { Aspect } from '@teambit/harmony';

export const GeneratorAspect = Aspect.create({
  id: 'teambit.generator/generator',
});
